import { render } from "./PolicyDetails.vue?vue&type=template&id=0832585c&scoped=true"
import script from "./PolicyDetails.vue?vue&type=script&lang=js"
export * from "./PolicyDetails.vue?vue&type=script&lang=js"

import "./PolicyDetails.vue?vue&type=style&index=0&id=0832585c&scoped=true&lang=css"

import exportComponent from "D:\\a\\1\\s\\ProtectionGuruVue\\client-app\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0832585c"]])

export default __exports__